/* global attachEvent, VideoPlayer, resetVideoPlayer */
const oldVideo = document.querySelector('.concert-video .video__iframe-container');

// Open tv fullscreen
attachEvent('.video__fullscreen-trigger', 'click', (ev) => {
  // Open modal
  const parentElem = ev.target.closest('.concert-video-wrapper');
  const tvFullScreen = parentElem.querySelector('.tv-fullscreen');
  tvFullScreen.classList.add('is-open-modal');

  if (parentElem.querySelector('[data-video-wrapper]')) {
    VideoPlayer(tvFullScreen);
    const videoParent = parentElem.querySelector('[data-video-wrapper]');
    resetVideoPlayer(videoParent);
  } else {
    const videoParent = tvFullScreen.querySelector('[data-video-wrapper-stream]');
    const streamIframe = videoParent.querySelector('.video__iframe-container');
    const video = videoParent.querySelector('.video');
    streamIframe.src += '?&autoplay=1';
    oldVideo.src = streamIframe.src.replace('?&autoplay=1', '');
    video.classList.add('is-playing');
  }

  ev.preventDefault();
});
